/**
 * Created by andrey on 09.02.2021.
 */

const Map2dDecoratorView = cc.Node.extend({
    ctor: function (decorator) {
        this._super();

        this.decorator = decorator;

        this.createImage();
        this.updateDecorator();
        this.changeSkin(this.decorator.getSkin(), true);
        this.updateVisibility();

        this.decorator.isOnScreen = this.createListener(this.isOnScreen.bind(this));
        this.decorator.onSmile = this.createListener(this.smile.bind(this));
        this.decorator.getView = this.createListener(() => this);

        this.decorator.onAnimateHover = this.createListener(this.animateHover.bind(this));
        this.decorator.onStopAnimateHover = this.createListener(this.stopAnimateHover.bind(this));
        this.decorator.onSetSkin = this.createListener(this.changeSkin.bind(this));
        this.decorator.onSetAnimation = this.createListener(this.changeAnimation.bind(this));
        this.decorator.onSetVisible = this.createListener(this.updateVisibility.bind(this));
        this.decorator.onRemove = this.createListener(this.removeFromParent.bind(this));
    },

    createImage: function () {
        const decorator = this.decorator;
        
        const image = this.image = Map2dDecoratorView.getDecoratorImage(decorator);
        this.addChild(image);

        if (cleverapps.config.adminMode) {
            if (image instanceof cleverapps.Spine && image.hasAnimation("smile")) {
                image.setAnimation(0, "smile", true);
            }
        }

        this.setContentSize2(image);
        image.setPosition(image.width / 2, image.height / 2);

        const useAnchorBone = image.getAnchorBone && image.getAnchorBone();

        if (useAnchorBone) {
            this.setAnchorPoint(image.getAnchorPoint());
            image.setAnchorPoint(0.5, 0.5);
        } else {
            this.setAnchorPoint(0.5, 0.5);
        }
    },

    updateDecorator: function (fromChange) {
        const decorator = this.decorator;

        let dx = (decorator.dx || 0) * resolutionScale;
        let dy = (decorator.dy || 0) * resolutionScale;

        if (fromChange) {
            const cell = Map2d.currentMap.getMapView().getCell(this.decorator.x, this.decorator.y);
            dx += cell.x;
            dy += cell.y;
        }

        if (dx || dy) {
            this.setPosition(dx, dy);
        }

        this.setRotation(decorator.rotation || 0);
        this.setScale(decorator.scaleX || 1, decorator.scaleY || 1);
        this.setLocalZOrder(decorator.getLocalZOrder());
    },

    updateVisibility: function () {
        this.setVisible(this.decorator.visible);
    },

    isOnScreen: function () {
        return this.image.isVisible() && cleverapps.UI.isNodeOnScene(this.image, 2, 2);
    },

    smile: function () {
        this.image.setCompleteListener(() => {
            this.image.setCompleteListener();
            this.image.setAnimationAndIdleAfter("smile", "animation");

            if (!Map2dDecoratorView.smileSoundTimeouts[this.decorator.code] || Date.now() > Map2dDecoratorView.smileSoundTimeouts[this.decorator.code] + Map2dDecoratorView.SMILE_SOUND_THROTTLE) {
                Map2dDecoratorView.smileSoundTimeouts[this.decorator.code] = Date.now();
                cleverapps.effects.fire(`decorator.smile.${this.decorator.code}`, this);
            }
        });
    },

    animateHover: function () {
        if (this.image instanceof cleverapps.Spine) {
            const blink = StandartAnimations.blink(this.image.spine, {
                brightness: 0.3
            });
            this.hoverAnimation = this.image.spine.runAction(
                new cc.RepeatForever(blink)
            );
            this.hoverAnimation.setFinalize(() => {
                blink.stop();
            });
        }
    },

    stopAnimateHover: function () {
        if (this.hoverAnimation) {
            this.image.spine.stopAction(this.hoverAnimation);
            delete this.hoverAnimation;
        }
    },

    changeSkin: function (skin, silent) {
        if (!(this.image instanceof cleverapps.Spine) || !this.image.hasSkin(skin)) {
            return;
        }

        this.image.setSkin(skin);

        if (!silent && this.image.hasAnimation("change")) {
            let idleAnimation = this.decorator.getAnimation();
            if (!this.image.hasAnimation(idleAnimation)) {
                idleAnimation = Map2dDecoratorView.getDefaultAnimation(this.image);
            }
            this.image.setAnimationAndIdleAfter("change", idleAnimation);
        }
    },

    changeAnimation: function (animation, silent, options) {
        options = options || {};
        const callback = options.callback || function () {};
        if (!(this.image instanceof cleverapps.Spine) || !this.image.hasAnimation(animation)) {
            return;
        }

        const changeAnimation = options.changeAnimation;

        if (silent || !this.image.hasAnimation(changeAnimation)) {
            this.image.setAnimation(0, animation);
            callback();
        } else {
            this.image.setAnimationAndIdleAfter(changeAnimation, animation);
            this.image.setCompleteListenerOnce(callback);
        }
    },

    checkTouchInside: function (touch) {
        return UnitView.targetContainPoint(this, this.convertTouchToNodeSpace(touch));
    }
});

Map2dDecoratorView.processDecoratorUrl = function (decorator) {
    const index = decorator.code && decorator.code.indexOf("#");
    if (index > -1) {
        return {
            bundle: decorator.code.slice(0, index),
            url: decorator.code.slice(index + 1)
        };
    }

    return {
        bundle: `decorator_${decorator.code}`,
        url: `decorator_${decorator.code}`
    };
};

Map2dDecoratorView.getFrame = function (decorator) {
    const url = Map2dDecoratorView.processDecoratorUrl(decorator);
    return bundles[url.bundle] && bundles[url.bundle].frames[url.url];
};

Map2dDecoratorView.getJson = function (decorator) {
    const url = Map2dDecoratorView.processDecoratorUrl(decorator);
    return bundles[url.bundle] && bundles[url.bundle].jsons[url.url];
};

Map2dDecoratorView.DecoratorImageExists = function (decorator) {
    return Map2dDecoratorView.getJson(decorator) || Map2dDecoratorView.getFrame(decorator);
};

Map2dDecoratorView.getDefaultAnimation = function (animation) {
    let animationName = cleverapps.config.editorMode ? "animation" : "idle";
    if (!animation.hasAnimation(animationName)) {
        animationName = animationName === "animation" ? "idle" : "animation";
    }
    return animationName;
};

Map2dDecoratorView.getDecoratorImage = function (decorator) {
    let image = Map2dDecoratorView.getJson(decorator);
    if (image) {
        if (cleverapps.config.debugMode && image && !image.resolve()) {
            throw `Name ${decorator.code} already used for spine decorator. Please rename sprite decorator ${decorator.code}`;
        }

        const animation = new cleverapps.Spine(image);

        let animationName = decorator.getAnimation();
        if (!animation.hasAnimation(animationName)) {
            animationName = Map2dDecoratorView.getDefaultAnimation(animation);
        }
       
        animation.setAnimation(0, animationName, true);

        return animation;
    }

    image = Map2dDecoratorView.getFrame(decorator);

    if (image) {
        return new cc.Sprite(image);
    }

    throw `Not found resources for decorator ${decorator.code}`;
};

Map2dDecoratorView.smileSoundTimeouts = {};
Map2dDecoratorView.SMILE_SOUND_THROTTLE = cleverapps.parseInterval("5 seconds");
